import { axiosInstance } from "../../../../Services";
import { MMH_PRODUCTS_BASE_PATH, USE_MOCK } from "./config";
import { mockGetProductById } from "../mock/mockApi";

// READ (single) — GET /internal/mmh-products/:id
// Resolves to { data: { data: product } } where product.images is the full
// image list with per-image tagging fields.
export const GetMMHProductById = async (id) => {
  if (USE_MOCK) {
    return mockGetProductById(id);
  }
  return axiosInstance.get(`${MMH_PRODUCTS_BASE_PATH}/${id}`);
};

export default GetMMHProductById;
